import React from 'react';
import {
  Box,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Tooltip,
} from '@mui/material';

import { MessageAction, ACTOR_TYPES } from '../../../types';

interface MessageActionEditorProps {
  action: MessageAction;
  onChange: (action: MessageAction) => void;
}

const MessageActionEditor: React.FC<MessageActionEditorProps> = ({ action, onChange }) => {
  const handleChange = (field: keyof MessageAction['data'], value: any) => {
    onChange({
      ...action,
      data: {
        ...action.data,
        [field]: value,
      },
    });
  };

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <TextField
        label="Message Text"
        value={action.data.text}
        onChange={(e) => handleChange('text', e.target.value)}
        multiline
        rows={3}
        fullWidth
        helperText="Use {{variableName}} to insert context values"
      />

      <Box display="flex" gap={2}>
        <FormControl sx={{ minWidth: 120 }}>
          <InputLabel>Actor</InputLabel>
          <Select
            value={action.data.actor}
            label="Actor"
            onChange={(e) => handleChange('actor', e.target.value)}
          >
            <MenuItem value={ACTOR_TYPES.BOT}>Bot</MenuItem>
            <MenuItem value={ACTOR_TYPES.USER}>User</MenuItem>
          </Select>
        </FormControl>

        <Tooltip title="Optional delay in milliseconds before showing the message">
          <TextField
            label="Delay (ms)"
            type="number"
            value={action.data.delay || ''}
            onChange={(e) =>
              handleChange('delay', e.target.value ? parseInt(e.target.value, 10) : undefined)
            }
            sx={{ width: 150 }}
            placeholder="1000"
          />
        </Tooltip>
      </Box>

      {action.data.delay && (
        <Typography variant="caption" color="text.secondary">
          A loading spinner will be shown for {action.data.delay}ms before displaying the message
        </Typography>
      )}
    </Box>
  );
};

export default MessageActionEditor;
